import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import { privacy } from './Privacy'
import { terms } from './Terms'

export default class Page extends Component {
  componentWillMount(){
    switch (this.props.location.pathname) {
      case '/privacy':
        this.setState({page: privacy})
        break
      case '/terms':
        this.setState({page: terms})
        break
      default:
        break
    }
  }

  render () {
    return (
      <div className="mw7 center ph3">
        <ReactMarkdown source={this.state.page} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Pages/Page.js